/** Каталог підписів модуля (українська — основна мова, англійська — пізніше перекладом). */
export default {
  'nav.tasks': 'Демо-задачі',
  'panel.deadline': 'Термін',
  'panel.deadline.none': 'Без терміну',
  'panel.deadline.overdue': 'Прострочено',
  'panel.deadline.left': 'Лишилось',
  'panel.deadline.done': 'Завершено',
  'command.complete': 'Завершити демо-задачу',
  'command.complete.keywords': 'готово, закрити, виконано',
} as const;
